const registerModule = {
  title1: "전화번호를 입력하십시오",
  title2: "문자 메시지로 인증번호를 보내드렸습니다.",
  register: "등기",
  nextStep: "다음",
  areaCodeTitle: "핸드폰 번호 선택",
  resendText: "*후 인증번호 재전송 가능",
  codePrompt: "인증번호 네 자리 입력하세요",
  setPassword: "비밀번호 설정",
  sendCodeText:
    "우리는 위의 번호에 문자 메시지 인증 번호를 보낼 것입니다.통신 상황의 영향으로, 문자 메시지 수신이 약간 지연될 수 있습니다.",
  isPhone: "드폰 번호를 입력하십시오",
  sendCodeAgain: "다시한번 문자로 보냈습니다*",
  sendSuccess: "발송 성공",
  passwordHint: "6-32자리 영문 또는 숫자 반각문자를 입력하세요",
  isPassword: "비밀번호를 입력하십시오",
  samePassword: "두 번의 비밀번호가 같지 않습니다",
  registerSuccess: "회원가입 성공",
  forgetPwTitle: "비밀번호 분실",
  newPassword: "새로운 비밀번호",
  restSuccess: "비밀번호 수정",
  sendCode: "인증 코드 가져오기",
  requiredEmail: '메일박스 기입해 주세요',
  phoneError: "핸드폰 번호 형식이 정확하지 않다.",
};

export default registerModule;
